import { render, staticRenderFns } from "./CrearCita.vue?vue&type=template&id=312d2245&scoped=true&"
import script from "./CrearCita.vue?vue&type=script&lang=ts&"
export * from "./CrearCita.vue?vue&type=script&lang=ts&"
import style0 from "./CrearCita.vue?vue&type=style&index=0&id=312d2245&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d2245",
  null
  
)

export default component.exports